module.exports = __webpack_public_path__ + "static/images/ios-tips-img.99bbc79.png";